import { z } from "zod";

// Single user presence data schema
export const userPresenceSchema = z
  .object({
    userId: z.string(),
    userName: z.string(),
    pageId: z.string().optional(),
    funnelId: z.string().optional(),
    isSuperuser: z.boolean(),
  })
  .describe("UserPresence");

// Project presence data schema -- broadcasted from the server to the clients
export const serverToClientWebsocketPresenceBroadcastDataSchema = z
  .object({
    projectPresence: z.array(
      z.object({
        userId: z.string(),
        userName: z.string(),
        isSuperuser: z.boolean(),
      }),
    ),
    pagePresence: z.record(
      z.string(),
      z.array(
        z.object({
          userId: z.string(),
          userName: z.string(),
          isSuperuser: z.boolean(),
        }),
      ),
    ),
    funnelPresence: z.record(
      z.string(),
      z.array(
        z.object({
          userId: z.string(),
          userName: z.string(),
          isSuperuser: z.boolean(),
        }),
      ),
    ),
  })
  .describe("ServerToClientWebsocketPresenceBroadcastData");

// Data sent from the clients to the server schema
export const clientToServerWebsocketCallbackDataSchema = z
  .discriminatedUnion("type", [
    z.object({
      type: z.literal("CONTENT_UPDATE"),
    }),
    z.object({
      type: z.literal("PRESENCE_UPDATE"),
      presenceData: userPresenceSchema,
    }),
  ])
  .describe("ClientToServerWebsocketCallbackData");

// Data sent from the server to the clients schema
export const serverToClientWebsocketBroadcastDataSchema = z
  .discriminatedUnion("type", [
    z.object({
      type: z.literal("CONTENT_UPDATE"),
    }),
    z.object({
      type: z.literal("PRESENCE_UPDATE"),
      presenceData: serverToClientWebsocketPresenceBroadcastDataSchema,
    }),
  ])
  .describe("ServerToClientWebsocketBroadcastData");
